export default {
  default: () => import("/opt/buildhome/repo/layouts/Default.vue")
}